export const theme = {
  colors: {
    background: "#f1f1f1",
    text: "#444",
    primary: "#E22F22",
    grey: "#e2e4e7",
    greyLight: "#fafafa",
    tags: {
      default: {
        bg: "#fafafa",
        text: "text",
        border: "#e2e4e7",
        icon: "white",
      },
      info: {
        bg: "#e5f5fa",
        text: "#29809a",
        border: "#bbe6f3",
        icon: "#beeffe",
      },
      warning: {
        bg: "#f8efae",
        text: "#7d6f04",
        border: "#eed202",
        icon: "#eed202",
      },
      error: {
        bg: "#ff4b3e",
        text: "#fafafa",
        border: "#eb756d",
        icon: "#eb756d",
      },
    },
  },
  spacing: [0, 4, 8, 16, 24, 32, 40, 48],
  fonts: {
    heading:
      "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen-Sans,Ubuntu,Cantarell,'Helvetica Neue',sans-serif",
  },
  radii: {
    radius: "3px",
  },
};
